import { useEffect, useState } from 'react';
import {
  normalizeProductDoors,
  isProductDoorOpen,
  filterNavItemsByDoors,
  closedProductDoors,
  PRODUCT_DOOR_KEYS,
} from '../../shared/productDoors.js';

function readUserFromStorage() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function doorsFromUser(user) {
  return normalizeProductDoors(user?.productDoors);
}

function sameProductDoors(left, right) {
  for (let i = 0; i < PRODUCT_DOOR_KEYS.length; i += 1) {
    const key = PRODUCT_DOOR_KEYS[i];
    if ((left?.[key] === true) !== (right?.[key] === true)) return false;
  }
  return true;
}

export function useProductDoors() {
  const [doors, setDoors] = useState(() => doorsFromUser(readUserFromStorage()));

  useEffect(() => {
    const sync = () => {
      const next = doorsFromUser(readUserFromStorage());
      setDoors((prev) => (sameProductDoors(prev, next) ? prev : next));
    };
    sync();
    window.addEventListener('storage', sync);
    window.addEventListener('focus', sync);
    window.addEventListener('visibilitychange', sync);
    window.addEventListener('fcp:user-updated', sync);
    const intervalId = window.setInterval(sync, 2000);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener('focus', sync);
      window.removeEventListener('visibilitychange', sync);
      window.removeEventListener('fcp:user-updated', sync);
      window.clearInterval(intervalId);
    };
  }, []);

  return doors;
}

export function useProductDoor(doorKey) {
  const doors = useProductDoors();
  return isProductDoorOpen(doors, doorKey);
}

export {
  normalizeProductDoors,
  isProductDoorOpen,
  filterNavItemsByDoors,
  closedProductDoors,
};
